import { useState } from "react";
import contactStyles from "./contactUs.module.css";
import { NavBar } from "../../components/layout/navbar/navbar";
import { urlConfig } from "../../config/urlConfig";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);

    try {
      const response = await fetch(
        `${urlConfig.BASE_URL}/api/enquiries`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ data: formData }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send your message. Please try again.");
      }

      setSuccess("Message sent successfully!");
      setFormData({ fullName: "", email: "", subject: "", message: "" });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <header className={contactStyles.hero_section}>
        <NavBar />
        <div className="container">
          <div className={contactStyles.text_section}>
            <h3 className={contactStyles.title}>Talk to our Support Team</h3>
            <p className={contactStyles.details}>
              We'll quickly respond to your requests and find the right
              investment for you.
            </p>
          </div>
        </div>
      </header>

      <section className={`${contactStyles.form_section} mh_cream_n_masked`}>
        <div className="container">
          <form
            className={`${contactStyles.form_container} contact_form`}
            onSubmit={handleSubmit}
          >
            <div className="form-group mb-4">
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className="form-control"
                placeholder="Full name"
                required
              />
            </div>
            <div className="form-group mb-4">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
                placeholder="Email"
                required
              />
            </div>
            <div className="form-group mb-4">
              <input
                type="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-control"
                placeholder="Phone Number"
                required
              />
            </div>
            <div className="form-group mb-4">
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="form-control"
                placeholder="Subject"
                required
              />
            </div>
            <div className="form-group mb-4">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="form-control"
                placeholder="Message"
                required
              ></textarea>
            </div>
            <button className="btn mh_secondary_btn" type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send"}
            </button>
            {success && <p className="text-success mt-3">{success}</p>}
            {error && <p className="text-danger mt-3">{error}</p>}
          </form>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
